<template>
  <BaseDropdown
    class="form-input-field"
    variant="outlined"
    persistent-placeholder
    color="brand"
    v-bind="$attrs"
  />
</template>
<script setup lang="ts">
import { BaseDropdown } from '@/components/base'
</script>
